export { default as EmailAiPromptsEditor } from './EmailAiPromptsEditor';
export { default as AiPromptsPage } from './AiPromptsPage';

export const moduleConfig = {
  module: {
    title: 'AI Prompts',
    description: 'Create and manage prompts for the email AI assistant drawer.',
  },
};
